export const en = {
    //VALIDATIONs
    businessevent_invalid_title:'Required (max {1}, letters/numbers only)',
    businessevent_invalid_description:'Required - Max {0}, letters/numbers and {1}',

    ewobusinessevent_invalid_impactedareas:'Required',
    ewobusinessevent_invalid_impactedmachine:'Required',
    ewobusinessevent_invalid_impactedmachineoperation:'Required',
    ewobusinessevent_invalid_impactedmachinesubgroup:'Required',
    ewobusinessevent_invalid_rootcause:'Required',
    ewobusinessevent_invalid_correctiveaction:'Required',
    ewobusinessevent_invalid_impacteddepartments:'Required',
    ewobusinessevent_invalid_calltime:'Required',
    ewobusinessevent_invalid_faultytime:'Required',
    ewobusinessevent_invalid_asset:'Required (max {1}, letters/numbers only)',
    ewobusinessevent_invalid_inmachine:'Required (max {1}, letters/numbers only)',
    ewobusinessevent_invalid_diagnosetime:'Required - Value greater than 0',
    ewobusinessevent_invalid_disassemblytime:'Required - Value greater than 0',
    ewobusinessevent_invalid_sparedeliverytime:'Required - Value greater than 0',
    ewobusinessevent_invalid_assemblytime:'Required - Value greater than 0',
    ewobusinessevent_invalid_startuptime:'Required - Value greater than 0',
    ewobusinessevent_invalid_solution:'Required - Max {0}, letters/numbers and {1}',

    //FILTER CONFIGURATION
    filter_title: 'Filter by',
    filter_confirmation_label: 'ok',
    filter_cancel_label: 'cancel',
    filter_ewo_description: 'ewo description',
    filter_ewo_event_code: 'event code',
    filter_ewo_creation_date: 'creation date',
    filter_ewo_business_impact: 'resolved / not resolved',
    filter_ewo_impacted_areas: 'ewo impacted areas',
    filter_ewo_impacted_machine: 'ewo impacted machine',
    reducer_label: 'Status',

    start_up_ending:'Startup Ending',
    downtime:"Downtime",
    waiting_time:'Waiting Time',
    creation_user_full_name:'Reported from *',
    event_code:'Event Code',
    ewo_reporting:'Ewo Reporting',
    search: 'Search in ',
    title: 'Title *',
    impacted_area: 'Impacted Area *',
    impacted_machine: 'Impacted Machine *',
    impacted_operation: 'Impacted Operation *',
    impacted_subgroup: 'Impacted Subgroup *',
    root_cause: 'Cause *',
    corrective_action: 'Corrective actions *',
    impacted_machine_component: 'Component',
    impacted_departments: 'Impacted Departments *',
    ewo_details: 'Ewo Details',
    new_ewo: 'New Ewo',
    save: 'Save',
    call_time: 'Call time *',
    faulty_time: 'Fault Time *',
    diagnose_time: 'Diagnosis time (min) *',
    minutes: 'minutes:',
    disassembly_time: 'Disassembly time (min) *',
    spare_delivery_time: 'Replacement time (min) *',
    assembly_time: 'Assembly time (min) *',
    start_up_time: 'Startup time (min) *',
    may_have_qa_impact: 'May have QA Impact',
    business_impact: 'Resolved?',
    description: 'Description *',
    close: 'Close',
    input_description: 'Input description...',
    please_fill_all_required_fields: 'Please fill all required (*) fields',
    solution: 'Solution *',
    input_solution: 'Input solution...',
    okay: 'OK',
    refresh: 'Refresh',
    take_on_charge_the_request: 'I take on charge the request...',
    months: 'Jan, Feb, Mar, Apr, May, Jun, Jul, Ago, Sep, Oct, Nov, Dec',
    stateMap:{
        'OPN': 'Opened',
        'CLD': 'Closed'
    },
    areasMap:{
        'RED':'Centro Ricerche',
        'IMPI':'Impianti',
        'SOFF':'Soffiaggio',
        'PRIN':'Presse iniezione',
        'STRZ':'Stampaggio rotazionale',
        'FIIN':'Finiture iniezione',
        'ROBO':'Robot',
        'FIRO':'Finiture rotazionale',
        'FISO':'Finiture soffiaggio'
    },
    machinesMap:{
        'ROTOSH':'Rotoplastic shuttle',
        'IPE250':'IPE 2500',
        'EQUIC':'Equlibratrice Cemb',
        'ROTO25':'Rotoplastic 2500',
        'PORT':'Portoni',
        'CARROP':'Carroponte',
        'PO35N':'Polivinil 3500 NEW',
        'NAW70524':'el.sy M157 NAW70524',
        'NAW70647':'el.sy M189 NAW70647',
        'NAV50034':'GS013 NAV 50034',
        'VA35N':'Vasca Polivnil 3500 new',
        //IMPI area
        'UFFI':'Uffici',
        'VIBRA':'Camera Test a Vibrazione e Fatica ',
        '3DSTRATA':'Stampante 3d Stratasys',
        'LABFLU':'Laboratorio Fluidinamico ',
        'BLOWER':'Blower Chamber',
        'CLIMACS':'Cella Climatica  ACS',
        'SERMAC':'Forno Sermac',
        'CLIMCH':'Cella Climatica  Challenge ',
        'TERMO':'Camera Termostatica ',
        'G751':'Compressore ga75 n°1',
        'G752':'Compressore ga75 n°2',
        'CVSD':'Compressore ga75 vsd',
        'GA55':'Compressore ga55',
        'GSVD':'Compressore ga55 vsd',
        'TOOP':'Torri evaporative',
        'CAST':'Caldaia stabilimento',
        'CAUF':'Caldaia uffici palazzina',
        'IMMA':'Impianto del materiale',
        'ADDO':'Addolcitore',
        'POZZ':'Pozzo',
        'CRPT':'Carroponti',
        'GRBA':'Gru a bandiera',
        'GRAM':'Gruppi di aspirazione materiale',

        //INIZ area
        'P247':'P247',
        'P231':'P231',
        'P503':'P503',
        'P504':'P504',
        'P230':'P230',
        'P218':'P218',
        'P220':'P220',
        'P225':'P225',
        'P248':'P248',
        'ENGE':'ENGEL',

        //SOFF area
        'P323':'P323',
        'P327':'P327',
        'P325':'P325',
        'P328':'P328',
        'P324':'P324',
        'P329':'P329',
        'UM20':'UMA 20',
        'CRPN':'Crane',

        //STRZ area
        'CA30':'Caccia 3000',
        'CA22':'Caccia 2200',
        'PO23':'Polivinil 2300',
        'PO35':'Polivinil 3500',
        'PARN':'Paranco',

        //FIIN area
        'AVDA':'Avvitatura daily',
        'RODA':'Rotofrizione daily',
        'EUMO':'Euromodel',
        '12X':'12X',
        '22X':'22X',
        '23x':'23x',
        '24x':'24x',
        '29x':'29x',
        '33x':'33x',
        'GS4U':'GS4 urea',
        'G14U':'GS014 urea',
        'COVA':'Collaudo vaschetta',
        'BRVE':'Branson vecchia',
        'BRNU':'Branson nuova',
        'COCO':'Conformatura coppa',
        'ATCO':'Avvitatore tappo coppa',
        'DICO':'Dimensionale coppa',
        'PTCO':'Prova tenuta coppa',
        'PTSU':'Prova tenuta succhieruola',
        'IMCO':'Imballaggio coppa',

        //ROBO
        'ROB1':'Robot 1',
        'ROB2':'Robot 2',
        'ROB3':'Robot 3',
        'SASN':'Saldatrice snorkel',
        'SASV':'Saldatrice snorkel vecchio',
        'BELO':'Belotti',

        //FIRO
        'VA22':'Vasca collaudo caccia 2200',
        'VA35':'Vasca  collaudo polivnil 3500',
        'VCBV':'Vasca collaudo banchi  vecchia',
        'VCBN':'Vasca collaudo banchi  nuova',
        'MLAP':'Macchina di lavaggio piccola',
        'MLAG':'Macchina di lavaggio grande',
        'BFIM':'Banchi finitura manuali',
        'BFIP':'Banchi di finitura con posaggio',

        //FISO
        'GS1':'GS1',
        'GS2':'GS2',
        'GS3':'GS3',
        'GS4':'GS4',
        'GS5':'GS5',
        'GS6':'GS6',
        'MOVE':'Modulare vecchia',
        'MONU':'Modulare nuova',
        'TAFA':'Taglierina famat',
        'TN37':'Taglierina NAV50037',
        'TN08':'Taglierina NAW5008',
        'AVRI':'Avvitatore RIMA',
        'ULHE':'Ultrasuoni Herman',
        'FTFB':'Finitura tfb',
        'MTFB':'Macchina collaudo tfb',
        'CATE':'Caterpillar'
    },
    operationsMap:{
        'EQUI':'Equilibratura',
        'PROV':'Prove',
        //IMPI area
        'SERV':"Servizi",

        //SUFF, PRIN, STRZ area
        'STPG':'Printing',

        //FIIN, ROBO area
        'COLL':'Collaudo',
        'SALD':'Saldatura',
        'TAGL':'Taglio',
        'ASMB':'Assemblaggio',
        'FORA':'Foratura',
        'AVVI':'Avvitatura',

        //FIRO
        'CONT':'Controllo',

        //FISO
        'ASSE':'Assemblaggio'
    },
    subgroupsMap:{
        'ALBE':'Albero',
        'TRAPA':'Trapani',
        'RIVE':'Rivetttatrice',
        'QUAE':'Quadro elettrico',
        'CARROP':'Carroponte',
        'PORT':'Porta',
        'RESIS':'Resistenza',
        'VENTI':'Ventilatore',
        'SICUR':'Sicurezze',
        'POMP':'Pompe',
        'CLIMA':'Climatizzatore',
        'MOTOR':'Motoriduttore',
        'FUNI':'Funi',
        'PULSA':'Pulsantiera',
        'PANOP':'Panello Operatore',
        'CALDA':'Caldaie',
        'MOBILI':'Mobili',
        'NEON':'Neon',
        //IMPI area
        'ESSI':'Essicatori',
        'DEUM':'Deumidificatori',
        'SILO':'Silos',
        'TUBI':'Tubi',
        'VALV':'Valvole',

        //PRIN area
        'CNID':'Centralina idraulica',
        'MNSC':'Manipolatore di scarico',
        'SATL':'Satellite',
        'GRCH':'Gruppo di chiusura',
        'GRIN':'Gruppo di iniezione',
        'CARR':'Carro',
        'GINO':'Ginocchiera',
        'GRLU':'Gruppo lubrifica',
        'STMP':'Stampo',
        'RIMA':'Ricevitore materiale',
        'CIID':'Circuito idraulic',
        'CIPN':'Circuito pneumatico',
        'CIEL':'Circuito elettrico',
        'CIAC':'Circuito acqua',
        'SICU':'Sicurezze',
        'RISC':'Riscaldamento',
        'COST':'Condizionamento stampo',
        'PNOP':'Pannello operatore',

        //SUFF area
        'TSES':'Testa di estrusione',
        'ESTA':'Estrusore A',
        'ESTB':'Estrusore B',
        'TAVA':'Tavola A',
        'TAVB':'Tavola B',
        'TAVO':'tavola',
        'CIST':'Chiusura stampo',
        'CHIA':'Chiusura stampo  A',
        'CHIB':'Chiusura stampo  B',
        'ROBO':'Robot',
        'PNSS':'Pinza ssw',
        'QASO':'Quadro eletrico su soppalco',
        'QAEL':'Quadro elettrico',
        'CRID':'Idraulico',
        'CREL':'Circuito elettrico',
        'CRAC':'Circuito acqua',
        'PULS':'Pulsantiera',
        'NASA':'Trasportatore A',
        'NASB':'Trasportatore B',
        'NSTR':'Trasportatore',

        //STRZ area
        'CAR1':'Carrello 1',
        'CAR2':'Carrello 2',
        'CAR3':'Carrello 3',
        'CAR4':'Carrello 4',
        'TES1':'Testa carrello 1',
        'TES2':'Testa carrello 2',
        'TES3':'Testa carrello 3',
        'TES4':'Testa carrello 4',
        'FORN':'Forno',
        'BRUC':'Bruciatore',
        'VEFO':'Ventola forno',
        'VEEF':'Ventola estrazione fumi',
        'POFO':'Porte forno',
        'VERA':'Ventola raffreddamento',
        'VEER':'Ventola estrazione raffreddamento',
        'PORA':'Porta raffreddamento',
        'QUEL':'Quadro elettrico',
        'IMAC':'Impianto acqua',
        'PEDA':'Pedana',

        //FIIN area
        'CEID':'Centralina idrulica',
        'POSA':'Posaggio',
        'CANC':'Cancello',
        'CABI':'Cabina',
        'GRSA':'Gruppo salita',
        'GRDI':'Gruppo discesa',
        'PARA':'Parametri',
        'LACA':'Lama calda',
        'CIRV':'Circuito del vuoto',
        'TEVI':'Testa vibrante',
        'AVV1':'Avvitatore 1',
        'AVV2':'Avvitatore 2',
        'MAET':'Manipolatore etichetta',
        'SPVI':'Sparovite',
        'VIBR':'Vibratore',

        //ROBO
        'TARO':'Tavola rotante',
        'TESA':'Testa di saldatura',
        'MATA':'Mandrino di taglio',
        'NATR':'Nastro trasportatore',
        'CIVU':'Circuito vuoto',
        'ASMA':'Asse macchina',
        'PAOP':'Pannello operatore',

        //FIRO
        'BILA':'Bilancia',

        //FISO
        'SPIN':'spine',
        'IMPN':'impianto pneumatico',
        'CAFN':'cabina fnitura',

        'STAM':'Stampo'
    },

    causesMap:{
        'MCBA':'Mancanza condizioni di base',
        'MAMZ':'Mancanza manutenzione',
        'MOCO':'Mancata osservanza condizioni operative',
        'DEPR':'Debolezza di progetto',
        'INES':'Influenza esterna',
        'RIEA':'Ricambi inadeguati, eventi accidentali'
    },
    correctiveMap:{
        'REGO':'Regolazione',
        'SOST':'Sostituzione',
        'PULI':'Pulizia',
        'INGR':'Ingrassaggio',
        'REVI':'Revisione'
    },
    departmentsMap:{
        'PROD':'Production',
        'MTZ':'Maintenance'
    },
    downloading_file: `Downloading file...`,
    reset_filter:'Reset Filter',
    welcome_in_cornaglia:'Welcome in Cornaglia!',
    knowledge_base:'Knowledge Base'
};

//only on "en" file.
export type Translation = typeof en;